import axiosHttp from "../axiosHttp";
import tools from "COMJS/tools"

export default {
    queryByInfoAtPage(pageInfo,searchInfo){
        let url = "/ganjin/dealerSerialInfo/queryByInfoAtPage"
        let param = {
            "pageNo":pageInfo.pageNo,
            "pageSize":pageInfo.pageSize,
            "dealerAccount":searchInfo.dealerAccount,
            "openTime":(searchInfo.timeRange && searchInfo.timeRange.length>0)?tools.formatDate(searchInfo.timeRange[0],'yyyy-MM-dd hh:mm:ss'):null,
            "endTime":(searchInfo.timeRange && searchInfo.timeRange.length>1)?tools.formatDate(searchInfo.timeRange[1],'yyyy-MM-dd hh:mm:ss'):null
        }
        //console.log(param.openTime)
        //console.log(param.endTime)
        return axiosHttp.POST(url,param)
    },
    queryAtPage(pageInfo,searchConfig){
        let url = "/ganjin/dealerSerialInfo/queryAtPage?"
        if (pageInfo) {
            url = url + pageInfo.buildQueryString();
        }
        url += "&" + searchConfig.buildQueryString();
        return axiosHttp.GET(url)
    },
    save(param){
        let url = "/ganjin/dealerSerialInfo/save"
        return axiosHttp.POST(url,param)
    },
    findBySerialNumber(id) {
        return axiosHttp.GET(`/ganjin/dealerSerialInfo/findBySerialNumber/${id}`)
    },
    querySerialInStateAtPage(param) {
        return axiosHttp.POST(`/ganjin/dealerSerialInfo/querySerialInStateAtPage`,param)
    },
    delSerialNumber(list) {
        return axiosHttp.POST(`/ganjin/dealerSerialInfo/delSerialNumber`,list)
    },

}